module.exports = __webpack_public_path__ + "static/english-5af74f25978b01df46dc5f07503f6ce3.jpg";